$(function(){
/*==============================================================================
処理
==============================================================================*/
//========== ナビゲーション ==========
let navContents={
	btn:'#menu-trigger>a',
	cnt:'nav>div',
	active:'active'
}
$(navContents.btn).click(function(){
	$(navContents.btn).toggleClass(navContents.active);
	$(navContents.cnt).fadeToggle();
	return false;
});

//========== ドロワーclass追加 ==========
/*
let drawerContents={
	btn:'.drawer_btn>a',
	cnt:'.drawer_cnt',
	active:'drawer_active'
}
$(drawerContents.btn).click(function(){
	$(drawerContents.btn).toggleClass(drawerContents.active);
	$(drawerContents.cnt).slideToggle();
	return false;
});
*/
/*==============================================================================
スクロールアニメーション時の処理
==============================================================================*/
function scrollAnimation(bool){
	if(bool){
		//===== オプション =====
		let options={
			//root:null, //交差の基準となる親要素を指定(初期値はdocument)
			rootMargin: '0px 0px -10% 0px' //下端から10%入ったところで発火
			//threshold: [0, 0.5, 1.0] //要素を検出したいratioを0-1の間で指定が可能(初期値は0,1のみ)
		}
		//===== 交差を検出した際に呼ばれるコールバック =====
		const callback=function(entries,observer){
			entries.forEach(function(e){
				//===== 交差した時の処理 =====
				if(e.isIntersecting){
					//e.target.classList.add('fadeInUp'); //data-animationの値をclassに挿入
					//e.target.dataset.name='animation';
					e.target.dataset.animation='on';
					observer.unobserve(e.target); //指定した要素のobserveを解除する
				}
				else{
					return;
				}
			})
		}
		const observer=new IntersectionObserver(callback,options);

		//===== 交差を検出したい要素を登録 =====
		let target=document.querySelectorAll('.animation'); //監視したい要素をNodeListで取得
		for(let i=0; i<target.length; i++){
			observer.observe(target[i]); //要素の監視を開始
		}
	}
	else{
		observer.disconnect(); //登録されている全ての要素のobserveを解除する
	}
}

/*==============================================================================
読み込み時・レスポンシブ時の処理
==============================================================================*/
//========== デバイスサイズ変数 ==========
let deviceWidth={
	tablet:560,
	desktop:1100,
	flag:''
}
//========== ウインドウサイズ変数 ==========
let windowSize={
	w:null,
	h:null
}
function resizeDevice(){
	windowSize.w=$(window).width();

	//========== モバイル ==========
	if(windowSize.w<=deviceWidth.tablet && deviceWidth.flag!='mobile'){
		deviceWidth.flag='mobile';

		//ナビゲーション
		navActive(deviceWidth.flag,navContents);

		//スクロールアニメーション
		scrollAnimation(false);
	}
	//========== タブレット ==========
	else if((windowSize.w>deviceWidth.tablet && windowSize.w<=deviceWidth.desktop) && deviceWidth.flag!='tablet'){
		deviceWidth.flag='tablet';

		//ナビゲーション
		navActive(deviceWidth.flag,navContents);

		//スクロールアニメーション
		scrollAnimation(false);
	}
	//========== デスクトップ ==========
	else if(windowSize.w>deviceWidth.desktop && deviceWidth.flag!='desktop'){
		deviceWidth.flag='desktop';

		//ナビゲーション
		navActive(deviceWidth.flag,navContents);

		//スクロールアニメーション
		scrollAnimation(true);
	}
}
$(window).on('load',resizeDevice());
$(window).on('resize',resizeDevice());
/*==============================================================================
スクロール時の処理
==============================================================================*/
//========== スクロール値の変数 ==========
var scrollValue={
	top:null,
	bottom:null,
	startPos:0
}
$(window).on('scroll',function(){
	scrollValue.top=$(this).scrollTop();

	//headerに「class="active"」を追加
	if($('body').hasClass('home') && scrollValue.top<10){
		$('header').addClass('active');
	}else{
		$('header').removeClass('active');
	}

	//上スクロール時に「#side-nav」にclass付与
	if(deviceWidth.flag!='desktop'){
		$('#side-nav').removeClass('side-show');
		if(scrollValue.top>=scrollValue.startPos){
			$('#side-nav').removeClass('show');
		}else{
			$('#side-nav').addClass('show');
		}
		scrollValue.startPos=scrollValue.top;
	}else{
		$('#side-nav').removeClass('show');
		if(scrollValue.top<10){
			$('#side-nav').removeClass('side-show');
		}else{
			$('#side-nav').addClass('side-show');
		}
	}


});
//更新時
/*if($('body').hasClass('home') && $(window).scrollTop()>0){
	$('header').removeClass('active');
}*/

/*==============================================================================
関数
==============================================================================*/
//========== ナビゲーション .active削除 ==========
function navActive(deviceFlag,navContents){
	if(deviceFlag=='desktop'){
		if($(navContents.btn).hasClass(navContents.active)){
			$(navContents.btn).removeClass(navContents.active);
		}
		if($(navContents.cnt).hasClass(navContents.active)){
			$(navContents.cnt).removeClass(navContents.active);
		}
	}
}

});
